import React from "react";
import { Grid } from "@mui/material";
import { UserAvatar } from "./UserAvatar";
import { UserFormFields } from "./UserFormFields";
import { useUserProfileForm } from "../hooks/useUserProfileForm";

function UserProfileForm({ profileData, userId }) {
  const { fileInputRef, handleFileChange, preview, teamsArray } =
    useUserProfileForm({ profileData, userId });

  return (
    <Grid item xs={6.5} pl={8} className="d-flex flex-dir-col user-profile-container">
      <UserAvatar
        preview={preview}
        profileData={profileData}
        fileInputRef={fileInputRef}
        handleFileChange={handleFileChange}
      />
      <UserFormFields teamsArray={teamsArray} />
    </Grid>
  );
}





export default React.memo(UserProfileForm); 
